import React from 'react';
import { Radio } from 'antd';
import './BeneficiaryTypeTab.scss';

const RadioGroup = Radio.Group;

export default class BeneficiaryTypeTab extends React.Component {

  state = {
    selectedBeneficiaryType: this.props.value
  };

  onBeneficiaryTypeSelected = e => {
    this.setState({
      selectedBeneficiaryType: e.target.value
    }, () => this.props.onBeneficiaryTypeSelected(e.target.value));
  };

  render() {
    let disabledInd = false;
    let disabledCorp = false;
    let selectedBeneficiary = this.props.selectedBeneficiary;
    if (selectedBeneficiary) {
      if (selectedBeneficiary.beneficiaryType === 'CORPORATE') {
        disabledInd = true;
      } else {
        disabledCorp = true;
      }
    }
    return (
      <>
        <RadioGroup size="large" value={this.props.value}
                    onChange={this.onBeneficiaryTypeSelected}>
          <Radio.Button disabled={disabledInd} value="INDIVIDUAL">Personal</Radio.Button>
          {this.props.corpAllow === "true" && (
            <Radio.Button disabled={disabledCorp} value="CORPORATE">Corporate</Radio.Button>
          )}
         
        </RadioGroup>
      </>
    )
  }
}
